<template>
  <section
    v-if="showLoginLayer"
    class="fixed inset-0 z-[2224] flex items-center justify-center bg-[rgba(9,20,51,0.48)] px-[24px] py-[32px]"
  >
    <section
      v-if="showLoginLayer"
      class="login-modal-panel relative flex overflow-clip bg-white shadow-[0_24px_80px_rgba(8,19,62,0.18)]"
      :class="[narrow ? 'h-full w-full flex-col rounded-[0px]' : 'h-[558px] w-[791px] rounded-[28px]']"
      @click="countryPanelVisible = false"
    >
      <div
        class="relative flex shrink-0 flex-col bg-white"
        :class="[narrow ? 'w-full px-[24px] py-[32px]' : 'z-10 w-[476px] px-[48px] py-[40px]']"
      >
        <div class="flex flex-1 flex-col">
          <h2 class="text-[24px] leading-[32px] font-semibold text-[#292a2e]">
            {{ activeTab === 'phone' ? t('82907') : t('82902') }}
          </h2>

          <div class="flex flex-1 flex-col justify-between" :class="[narrow ? 'w-full' : 'w-[380px]']">
            <div class="pt-[32px]">
              <div v-if="activeTab === 'account'" class="space-y-[20px]">
                <template v-if="visibleAccountView === 'accountEntry'">
                  <div class="space-y-[16px]">
                    <label class="block">
                      <div class="border-b border-[rgba(5,21,36,0.06)] pb-[16px]">
                        <input
                          v-model="accountForm.account"
                          type="text"
                          name="username"
                          autocomplete="username"
                          class="h-[30px] w-full bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                          :placeholder="t('83719')"
                          @keydown.enter="submit"
                        />
                      </div>
                    </label>
                    <p v-if="accountForm.accountError" class="text-[13px] leading-[20px] text-[#e2483d]">
                      {{ accountForm.accountError }}
                    </p>

                    <label class="block">
                      <div class="flex w-full flex-col gap-[16px] pt-[8px]">
                        <div class="flex items-center">
                          <input
                            v-model="accountForm.loginPassword"
                            :type="showLoginPassword ? 'text' : 'password'"
                            name="current-password"
                            autocomplete="current-password"
                            class="h-[22px] min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                            :placeholder="t('82415')"
                            @keydown.enter="submit"
                          />
                          <div
                            class="ml-[12px] flex shrink-0 items-center justify-end gap-[24px] rtl:mr-[12px] rtl:ml-0 rtl:flex-row-reverse rtl:justify-start"
                          >
                            <button
                              v-if="accountForm.loginPassword"
                              type="button"
                              class="flex h-[20px] w-[20px] cursor-pointer items-center justify-center rounded-full bg-[#eef0f4] text-[#8c8f97] transition-colors hover:bg-[#e3e6ec] hover:text-[#292a2e]"
                              aria-label="清空密码"
                              @click.stop="accountForm.loginPassword = ''"
                            >
                              <CloseBoldIcon />
                            </button>
                            <button
                              type="button"
                              class="flex h-[16px] w-[16px] cursor-pointer items-center justify-center text-[#292a2e]"
                              :aria-label="showLoginPassword ? '隐藏密码' : '显示密码'"
                              @click.stop="showLoginPassword = !showLoginPassword"
                            >
                              <HiddenIcon v-if="!showLoginPassword" class="h-[16px] w-[16px]" />
                              <ShowIcon v-else class="h-[16px] w-[16px]" />
                            </button>
                          </div>
                        </div>
                        <div class="h-[1px] w-full bg-[rgba(5,21,36,0.06)]"></div>
                      </div>
                    </label>
                    <p v-if="accountForm.loginPasswordError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                      {{ accountForm.loginPasswordError }}
                    </p>

                    <div v-if="showForgotPasswordLink" class="flex h-[22px] w-full items-center justify-end">
                      <button
                        type="button"
                        class="cursor-pointer text-[14px] leading-[22px] text-[#0d3f63] hover:text-[#0a3150]"
                        @click.stop="openResetFlow()"
                      >
                        {{ t('82906') }}
                      </button>
                    </div>
                  </div>
                </template>

                <template v-else-if="visibleAccountView === 'accountPasswordLogin'">
                  <div class="space-y-[16px]">
                    <div class="flex w-full flex-col gap-[16px] pt-[8px]">
                      <div class="flex items-center justify-between gap-[12px]">
                        <input
                          v-model="accountForm.account"
                          type="text"
                          name="username"
                          autocomplete="username"
                          class="h-[22px] min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                          :placeholder="t('83719')"
                          @keydown.enter="submit"
                        />
                        <button
                          type="button"
                          class="flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full bg-[#eef0f4] text-[#8c8f97] transition-colors hover:bg-[#e3e6ec] hover:text-[#292a2e]"
                          aria-label="清空邮箱"
                          @click.stop="clearAccountAndBackToEntry()"
                        >
                          <CloseBoldIcon />
                        </button>
                      </div>
                      <div class="h-[1px] w-full bg-[rgba(5,21,36,0.06)]"></div>
                    </div>
                    <p v-if="accountForm.accountError" class="text-[13px] leading-[20px] text-[#e2483d]">
                      {{ accountForm.accountError }}
                    </p>
                  </div>

                  <label class="block">
                    <div class="flex w-full flex-col gap-[16px] pt-[8px]">
                      <div class="flex items-center">
                        <input
                          v-model="accountForm.loginPassword"
                          :type="showLoginPassword ? 'text' : 'password'"
                          name="current-password"
                          autocomplete="current-password"
                          class="h-[22px] min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                          :placeholder="t('82415')"
                          @keydown.enter="submit"
                        />
                        <div
                          class="ml-[12px] flex shrink-0 items-center justify-end gap-[24px] rtl:mr-[12px] rtl:ml-0 rtl:flex-row-reverse rtl:justify-start"
                        >
                          <button
                            v-if="accountForm.loginPassword"
                            type="button"
                            class="flex h-[20px] w-[20px] cursor-pointer items-center justify-center rounded-full bg-[#eef0f4] text-[#8c8f97] transition-colors hover:bg-[#e3e6ec] hover:text-[#292a2e]"
                            aria-label="清空密码"
                            @click.stop="accountForm.loginPassword = ''"
                          >
                            <CloseBoldIcon />
                          </button>
                          <button
                            type="button"
                            class="flex h-[16px] w-[16px] cursor-pointer items-center justify-center text-[#292a2e]"
                            :aria-label="showLoginPassword ? '隐藏密码' : '显示密码'"
                            @click.stop="showLoginPassword = !showLoginPassword"
                          >
                            <HiddenIcon v-if="!showLoginPassword" class="h-[16px] w-[16px]" />
                            <ShowIcon v-else class="h-[16px] w-[16px]" />
                          </button>
                        </div>
                      </div>
                      <div class="h-[1px] w-full bg-[rgba(5,21,36,0.06)]"></div>
                    </div>
                  </label>
                  <p v-if="accountForm.loginPasswordError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                    {{ accountForm.loginPasswordError }}
                  </p>

                  <div v-if="showForgotPasswordLink" class="flex h-[22px] w-full items-center justify-end">
                    <button
                      type="button"
                      class="text-[14px] leading-[22px] text-[#0d3f63]"
                      @click.stop="openResetFlow()"
                    >
                      {{ t('82906') }}
                    </button>
                  </div>
                </template>
              </div>

              <div v-else class="space-y-[16px]">
                <label class="block">
                  <div class="relative flex w-full flex-col gap-[16px] pt-[8px]">
                    <div class="flex h-[22px] items-center gap-[8px]">
                      <button
                        type="button"
                        class="flex shrink-0 cursor-pointer items-center gap-[4px] text-left hover:opacity-80"
                        aria-label="选择国家区号"
                        @click.stop="countryPanelVisible = !countryPanelVisible"
                      >
                        <CommonImage
                          :src="currentCountry.flag || ChinaFlag"
                          :alt="currentCountry.name || 'China'"
                          class="h-[16px] w-[24px] rounded-[2px] object-cover"
                        />
                        <span class="font-['WikiFX-Medium'] text-[14px] leading-[22px] text-[#292a2e]">
                          +{{ normalizedAreaCode }}
                        </span>
                        <img
                          src="https://resources1.interface003.com/web30/2026/06/01/5a6e0622-d50d-4dcc-bab6-747e48ea61c3.png"
                          class="size-[16px] object-contain"
                          alt=""
                        />
                      </button>
                      <input
                        v-model="phoneForm.phone"
                        type="text"
                        inputmode="numeric"
                        name="tel"
                        autocomplete="tel"
                        class="h-[22px] min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                        :placeholder="t('82402')"
                        @keydown.enter="submit"
                      />
                      <button
                        v-if="phoneForm.phone"
                        type="button"
                        class="flex size-[20px] shrink-0 cursor-pointer items-center justify-center rounded-full bg-[#eef0f4] text-[#8c8f97] transition-colors hover:bg-[#e3e6ec] hover:text-[#292a2e]"
                        aria-label="清空手机号"
                        @click.stop="phoneForm.phone = ''"
                      >
                        <CloseBoldIcon />
                      </button>
                    </div>
                    <div
                      class="h-[1px] w-full"
                      :class="phoneForm.phoneError ? 'bg-[#d84a4a]' : 'bg-[rgba(5,21,36,0.06)]'"
                    ></div>
                    <LoginCountryPanel :show="countryPanelVisible" @select="handleCountrySelect" />
                  </div>
                </label>
                <p v-if="phoneForm.phoneError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                  {{ phoneForm.phoneError }}
                </p>

                <label class="block">
                  <div class="flex w-full flex-col gap-[16px] pt-[8px]">
                    <div class="flex h-[22px] items-center justify-between gap-[16px]">
                      <input
                        v-model="phoneForm.smsCode"
                        type="text"
                        inputmode="numeric"
                        name="one-time-code"
                        autocomplete="one-time-code"
                        class="h-[22px] min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                        :placeholder="t('82403')"
                        maxlength="4"
                        @keydown.enter="submit"
                      />
                      <button
                        type="button"
                        class="shrink-0 cursor-pointer text-[14px] leading-[22px] text-[#0d3f63] hover:text-[#112d73]"
                        :class="phoneIsCountdown || !phoneForm.phone ? 'opacity-40' : ''"
                        @click.stop="sendPhoneCode()"
                      >
                        {{ phoneIsCountdown ? `${phoneCountDown}s` : t('82404') }}
                      </button>
                    </div>
                    <div class="h-[1px] w-full bg-[rgba(5,21,36,0.06)]"></div>
                  </div>
                </label>
                <p v-if="phoneForm.smsError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                  {{ phoneForm.smsError }}
                </p>
              </div>

              <button
                type="button"
                class="flex h-[46px] w-full cursor-pointer items-center justify-center rounded-[100px] text-[14px] leading-[22px] font-semibold"
                :class="[
                  activeTab === 'phone' ? 'mt-[16px]' : showForgotPasswordLink ? 'mt-[20px]' : 'mt-[28px]',
                  submitButtonClass,
                ]"
                :disabled="!mainSubmitEnabled || isSubmitting"
                @click="submit"
              >
                <span v-if="!isSubmitting">{{ submitLabel }}</span>
                <span v-else class="login-spinner"></span>
              </button>
            </div>

            <div v-if="activeTab === 'account'" class="pt-[20px]">
              <div class="flex items-center gap-[16px]">
                <div class="h-[1px] flex-1 bg-[rgba(5,21,36,0.06)]"></div>
                <span class="text-[12px] leading-[18px] text-[#8c8f97]">{{ t('82884') }}</span>
                <div class="h-[1px] flex-1 bg-[rgba(5,21,36,0.06)]"></div>
              </div>

              <div class="mt-[20px] flex items-center justify-center gap-[32px]">
                <button
                  type="button"
                  class="flex size-[44px] cursor-pointer items-center justify-center rounded-full border-[0.5px] border-[rgba(11,18,40,0.14)] bg-white text-[#292a2e] transition-colors hover:bg-[rgba(5,21,36,0.04)]"
                  aria-label="切换至手机号登录"
                  @click.stop="switchTab('phone')"
                >
                  <PhoneIcon class="size-[20px]" />
                </button>
                <template v-for="item in visibleSocialItems" :key="item.key">
                  <LoginGoogleButton
                    v-if="item.key === 'google'"
                    :label="item.label"
                    @credential="handleGoogleCredential"
                    @click="matomoLogo('谷歌')"
                  />
                  <LoginTelegramButton
                    v-else-if="item.key === 'telegram'"
                    :label="item.label"
                    @auth="handleTelegramAuth"
                    @click="matomoLogo('telegrame')"
                  />
                  <button
                    v-else-if="item.key === 'linkedin'"
                    type="button"
                    class="relative flex size-[44px] cursor-pointer items-center justify-center overflow-hidden rounded-full border-[0.5px] border-[rgba(11,18,40,0.14)] bg-white transition-colors hover:bg-[rgba(5,21,36,0.04)]"
                    :aria-label="item.label"
                    @click.stop="(handleSocialLogin('linkedin'), matomoLogo('领英'))"
                  >
                    <img :src="LinkedinIcon" alt="" class="size-[20px] rounded-[4px]" />
                  </button>
                  <button
                    v-else
                    type="button"
                    class="relative flex size-[44px] cursor-pointer items-center justify-center overflow-hidden rounded-full transition-colors hover:bg-[rgba(5,21,36,0.04)]"
                    :aria-label="item.label"
                    @click.stop="(handleSocialLogin(item.key), matomoLogo(item.key === 'apple' ? 'apple' : '微信'))"
                  >
                    <AppleIcon v-if="item.key === 'apple'" />
                    <WechatIcon v-else />
                  </button>
                </template>
              </div>
            </div>
          </div>
        </div>

        <button
          v-if="activeTab === 'phone'"
          type="button"
          class="absolute top-[456px] left-[155px] cursor-pointer text-[14px] leading-[22px] text-[#0d3f63] hover:text-[#112d73] rtl:right-[155px] rtl:left-auto"
          @click.stop="switchTab('account')"
        >
          {{ t('82919') }}
        </button>

        <button
          v-if="activeTab === 'account' && !isAccountFlowView"
          type="button"
          class="mt-[20px] flex w-full cursor-pointer items-center justify-center gap-[4px] text-[14px] leading-[22px] text-[#0d3f63] transition-colors hover:text-[#112d73]"
          aria-label="使用邮箱注册"
          @click.stop="startEmailRegistration()"
        >
          <svg class="size-[14px]" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path
              d="M1.75 3.5A1.75 1.75 0 0 1 3.5 1.75h7A1.75 1.75 0 0 1 12.25 3.5v7a1.75 1.75 0 0 1-1.75 1.75h-7a1.75 1.75 0 0 1-1.75-1.75v-7Z"
              stroke="currentColor"
              stroke-width="1.15"
            />
            <path d="m2.3 3.05 4.07 3.26a1 1 0 0 0 1.26 0l4.07-3.26" stroke="currentColor" stroke-width="1.15" />
          </svg>
          <span>{{ t('85523') }}</span>
        </button>

        <p v-if="activeTab === 'account'" class="mt-[20px] text-center text-[14px] leading-[22px] text-[#91969c]">
          {{ t('82885') }}
          <NuxtLink
            :to="localePath('/terms/service')"
            target="_blank"
            class="text-[#0d3f63]"
            @click="matomoLogo('用户协议')"
            >{{ t('82886') }}</NuxtLink
          >
          、
          <NuxtLink
            @click="matomoLogo('隐私政策')"
            :to="localePath('/terms/privacy')"
            target="_blank"
            class="text-[#0d3f63]"
            >{{ t('82887') }}</NuxtLink
          >
        </p>
      </div>

      <div
        class="relative flex shrink-0 flex-col items-center justify-center bg-[#f8f8f8]"
        :class="[narrow ? 'w-full px-[24px] py-[32px]' : 'w-[315px] px-[48px] py-[48px]']"
      >
        <button
          v-if="props.closebtn"
          type="button"
          class="absolute top-[24px] right-[24px] flex h-[24px] w-[24px] cursor-pointer items-center justify-center text-[#292a2e] rtl:right-auto rtl:left-[24px]"
          aria-label="关闭登录弹窗"
          @click="close"
        >
          <!-- <CloseIcon class="h-[24px] w-[24px]" /> -->
          <CommonImage
            src="https://resources1.interface003.com/web30/2026/07/13/28f031ef-ea50-4872-9368-559cdd89e3e5.png"
            class="h-[24px] w-[24px]"
          />
        </button>

        <LoginAppQrcode />
      </div>

      <div
        v-if="isAccountFlowView"
        class="absolute top-0 left-0 z-[20] flex h-full w-[476px] bg-white rtl:right-0 rtl:left-auto"
        @click.stop="countryPanelVisible = false"
      >
        <section
          class="login-account-flow relative flex w-full flex-col overflow-visible bg-white"
          :class="[narrow ? 'px-[24px] py-[32px]' : 'w-[476px] px-[48px] py-[40px]']"
          @click.stop
        >
          <div>
            <h3 class="text-[24px] leading-[32px] font-semibold text-[#292a2e]">{{ flowTitle }}</h3>
            <p
              v-if="flowDescription"
              :class="
                isEmailVerificationFlow
                  ? 'mt-[16px] text-[16px] leading-[24px] text-[#7d818a]'
                  : 'mt-[16px] text-[14px] leading-[24px] text-[#7d818a]'
              "
            >
              {{ flowDescription }}
            </p>
          </div>

          <div
            :class="
              isEmailVerificationFlow
                ? 'space-y-[16px] pt-[48px]'
                : flowDescription
                  ? 'space-y-[20px] pt-[32px]'
                  : 'space-y-[20px] pt-[40px]'
            "
          >
            <template v-if="accountView === 'registerCreatePassword'">
              <label class="block">
                <div
                  class="flex h-[46px] items-center justify-between rounded-[8px] border border-[rgba(5,21,36,0.06)] px-[16px]"
                >
                  <input
                    v-model="accountForm.registerPassword"
                    :type="showRegisterPassword ? 'text' : 'password'"
                    name="new-password"
                    autocomplete="new-password"
                    class="h-full min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    :placeholder="t('82415')"
                    @input="handlePasswordInput('registerPassword', $event)"
                    @keydown.enter="submit"
                  />
                  <div
                    class="ml-[12px] flex shrink-0 items-center justify-end gap-[24px] rtl:mr-[12px] rtl:ml-0 rtl:flex-row-reverse rtl:justify-start"
                  >
                    <button
                      v-if="accountForm.registerPassword"
                      type="button"
                      class="flex h-[20px] w-[20px] cursor-pointer items-center justify-center rounded-full bg-[#eef0f4] text-[#8c8f97] transition-colors hover:bg-[#e3e6ec] hover:text-[#292a2e]"
                      aria-label="清空密码"
                      @click.stop="accountForm.registerPassword = ''"
                    >
                      <CloseBoldIcon />
                    </button>
                    <button
                      type="button"
                      class="flex h-[16px] w-[16px] items-center justify-center text-[#292a2e]"
                      :aria-label="showRegisterPassword ? '隐藏密码' : '显示密码'"
                      @click.stop="showRegisterPassword = !showRegisterPassword"
                    >
                      <HiddenIcon v-if="!showRegisterPassword" class="h-[16px] w-[16px]" />
                      <ShowIcon v-else class="h-[16px] w-[16px]" />
                    </button>
                  </div>
                </div>
              </label>

              <label class="block">
                <div
                  class="flex h-[46px] items-center justify-between rounded-[8px] border border-[rgba(5,21,36,0.06)] px-[16px]"
                >
                  <input
                    v-model="accountForm.registerPasswordConfirm"
                    :type="showRegisterPasswordConfirm ? 'text' : 'password'"
                    name="new-password-confirm"
                    autocomplete="new-password"
                    class="h-full min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    :placeholder="t('82416')"
                    @input="handlePasswordInput('registerPasswordConfirm', $event)"
                    @keydown.enter="submit"
                  />
                  <div
                    class="ml-[12px] flex shrink-0 items-center justify-end gap-[24px] rtl:mr-[12px] rtl:ml-0 rtl:flex-row-reverse rtl:justify-start"
                  >
                    <button
                      v-if="accountForm.registerPasswordConfirm"
                      type="button"
                      class="flex h-[20px] w-[20px] items-center justify-center rounded-full bg-[#eef0f4] text-[#8c8f97] transition-colors hover:bg-[#e3e6ec] hover:text-[#292a2e]"
                      aria-label="清空确认密码"
                      @click.stop="accountForm.registerPasswordConfirm = ''"
                    >
                      <CloseBoldIcon />
                    </button>
                    <button
                      type="button"
                      class="flex h-[16px] w-[16px] items-center justify-center text-[#292a2e]"
                      :aria-label="showRegisterPasswordConfirm ? '隐藏确认密码' : '显示确认密码'"
                      @click.stop="showRegisterPasswordConfirm = !showRegisterPasswordConfirm"
                    >
                      <HiddenIcon v-if="!showRegisterPasswordConfirm" class="h-[16px] w-[16px]" />
                      <ShowIcon v-else class="h-[16px] w-[16px]" />
                    </button>
                  </div>
                </div>
              </label>

              <p v-if="accountForm.registerPasswordError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.registerPasswordError }}
              </p>
            </template>

            <template v-else-if="accountView === 'registerBindPhone'">
              <label class="block">
                <div
                  class="relative flex h-[46px] items-center gap-[12px] rounded-[8px] border border-[rgba(5,21,36,0.06)] px-[16px]"
                >
                  <button
                    type="button"
                    class="flex shrink-0 items-center gap-[4px]"
                    aria-label="选择国家区号"
                    @click.stop="countryPanelVisible = !countryPanelVisible"
                  >
                    <CommonImage
                      :src="currentCountry.flag || ChinaFlag"
                      :alt="currentCountry.name || 'China'"
                      class="h-[16px] w-[24px] rounded-[2px] object-cover"
                    />
                    <span class="text-[14px] leading-[22px] font-medium text-[#292a2e]">+{{ normalizedAreaCode }}</span>
                    <ArrowDownIcon class="h-[16px] w-[16px] text-[#292a2e]" />
                  </button>
                  <div class="h-[18px] w-[1px] shrink-0 bg-[rgba(5,21,36,0.08)]"></div>
                  <input
                    v-model="accountForm.registerPhone"
                    type="text"
                    inputmode="numeric"
                    name="tel"
                    autocomplete="tel"
                    class="h-full min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    :placeholder="t('82402')"
                  />

                  <LoginCountryPanel :show="countryPanelVisible" compact @select="handleCountrySelect" />
                </div>
              </label>
              <p v-if="accountForm.registerPhoneError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.registerPhoneError }}
              </p>

              <label class="block">
                <div
                  class="flex h-[46px] items-center justify-between gap-[16px] rounded-[8px] border border-[rgba(5,21,36,0.06)] px-[16px]"
                >
                  <input
                    v-model="accountForm.registerSmsCode"
                    type="text"
                    inputmode="numeric"
                    name="one-time-code"
                    autocomplete="one-time-code"
                    class="h-full min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    :placeholder="t('82403')"
                    maxlength="4"
                    @keydown.enter="submit"
                  />
                  <button
                    type="button"
                    class="shrink-0 cursor-pointer text-[14px] leading-[22px] text-[#0d3f63]"
                    :class="registerIsCountdown ? 'opacity-40' : ''"
                    @click.stop="sendRegisterCode()"
                  >
                    {{ registerIsCountdown ? `${registerCountdown}s` : t('82404') }}
                  </button>
                </div>
              </label>
              <p v-if="accountForm.registerSmsError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.registerSmsError }}
              </p>
              <p v-if="registerFiguresmsError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ registerFiguresmsError }}
              </p>
            </template>

            <template v-else-if="accountView === 'phoneBindEmail'">
              <label class="block">
                <div class="flex flex-col gap-[16px] pt-[8px] pb-[16px]">
                  <input
                    v-model="accountForm.registerEmail"
                    type="email"
                    name="email"
                    autocomplete="email"
                    class="h-[22px] w-full bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    :placeholder="t('82411')"
                  />
                </div>
              </label>
              <p v-if="accountForm.registerEmailError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.registerEmailError }}
              </p>

              <label class="block">
                <div class="flex flex-col gap-[16px] pt-[8px] pb-[16px]">
                  <div class="flex h-[22px] items-center justify-between gap-[16px]">
                    <input
                      v-model="accountForm.registerEmailCode"
                      type="text"
                      name="one-time-code"
                      autocomplete="one-time-code"
                      class="h-[22px] min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                      :placeholder="t('82412')"
                      @keydown.enter="submit"
                    />
                    <button
                      type="button"
                      class="shrink-0 cursor-pointer text-[14px] leading-[22px] text-[#0d3f63] hover:text-[#112d73]"
                      :class="registerEmailIsCountdown || !accountForm.registerEmail ? 'opacity-40' : ''"
                      @click.stop="sendPhoneBindEmailCode()"
                    >
                      {{ registerEmailIsCountdown ? `${registerEmailCountdown}s` : t('82404') }}
                    </button>
                  </div>
                </div>
              </label>
              <p v-if="accountForm.registerEmailCodeError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.registerEmailCodeError }}
              </p>
            </template>

            <template v-else-if="accountView === 'registerVerifyEmail' || accountView === 'thirdPartyBindEmail'">
              <label class="block">
                <div class="flex flex-col gap-[16px] pt-[8px] pb-[16px]">
                  <input
                    v-model="accountForm.registerEmail"
                    type="email"
                    name="email"
                    autocomplete="email"
                    class="h-[22px] w-full bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    :placeholder="t('82411')"
                  />
                </div>
              </label>
              <p v-if="accountForm.registerEmailError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.registerEmailError }}
              </p>

              <label class="block">
                <div class="flex flex-col gap-[16px] pt-[8px] pb-[16px]">
                  <div class="flex h-[22px] items-center justify-between gap-[16px]">
                    <input
                      v-model="accountForm.registerEmailCode"
                      type="text"
                      name="one-time-code"
                      autocomplete="one-time-code"
                      class="h-[22px] min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                      :placeholder="t('82412')"
                      @keydown.enter="submit"
                    />
                    <button
                      type="button"
                      class="shrink-0 cursor-pointer text-[14px] leading-[22px] text-[#0d3f63] hover:text-[#112d73]"
                      :class="registerEmailIsCountdown || !accountForm.registerEmail ? 'opacity-40' : ''"
                      @click.stop="
                        accountView === 'thirdPartyBindEmail' ? sendPhoneBindEmailCode() : sendRegisterEmailCode()
                      "
                    >
                      {{ registerEmailIsCountdown ? `${registerEmailCountdown}s` : t('82404') }}
                    </button>
                  </div>
                </div>
              </label>
              <p v-if="accountForm.registerEmailCodeError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.registerEmailCodeError }}
              </p>
            </template>

            <template v-else-if="accountView === 'resetVerifyEmail'">
              <label class="block">
                <div class="flex flex-col gap-[16px] pt-[8px] pb-[16px]">
                  <input
                    v-model="accountForm.resetEmail"
                    type="email"
                    name="email"
                    autocomplete="email"
                    class="h-[22px] w-full bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    :placeholder="t('82411')"
                  />
                </div>
              </label>
              <p v-if="accountForm.resetEmailError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.resetEmailError }}
              </p>

              <label class="block">
                <div class="flex flex-col gap-[16px] pt-[8px] pb-[16px]">
                  <div class="flex h-[22px] items-center justify-between gap-[16px]">
                    <input
                      v-model="accountForm.resetCode"
                      type="text"
                      name="one-time-code"
                      autocomplete="one-time-code"
                      class="h-[22px] min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                      :placeholder="t('82412')"
                      @keydown.enter="submit"
                    />
                    <button
                      type="button"
                      class="shrink-0 cursor-pointer text-[14px] leading-[22px] text-[#0d3f63] hover:text-[#112d73]"
                      :class="resetIsCountdown ? 'opacity-40' : ''"
                      @click.stop="sendResetCode()"
                    >
                      {{ resetIsCountdown ? `${resetCountdown}s` : t('82404') }}
                    </button>
                  </div>
                </div>
              </label>
              <p v-if="accountForm.resetCodeError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.resetCodeError }}
              </p>
            </template>

            <template v-else-if="accountView === 'resetNewPassword'">
              <label class="block">
                <div
                  class="flex h-[46px] items-center justify-between rounded-[8px] border border-[rgba(5,21,36,0.06)] px-[16px]"
                >
                  <input
                    v-model="accountForm.resetPassword"
                    :type="showResetPassword ? 'text' : 'password'"
                    name="new-password"
                    autocomplete="new-password"
                    class="h-full min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    placeholder="请输入新密码（6-20位密码）"
                    @input="handlePasswordInput('resetPassword', $event)"
                    @keydown.enter="submit"
                  />
                  <div
                    class="ml-[12px] flex shrink-0 items-center justify-end gap-[24px] rtl:mr-[12px] rtl:ml-0 rtl:flex-row-reverse rtl:justify-start"
                  >
                    <button
                      v-if="accountForm.resetPassword"
                      type="button"
                      class="flex h-[20px] w-[20px] cursor-pointer items-center justify-center rounded-full bg-[#eef0f4] text-[#8c8f97] transition-colors hover:bg-[#e3e6ec] hover:text-[#292a2e]"
                      aria-label="清空新密码"
                      @click.stop="accountForm.resetPassword = ''"
                    >
                      <CloseBoldIcon />
                    </button>
                    <button
                      type="button"
                      class="flex h-[16px] w-[16px] cursor-pointer items-center justify-center text-[#7d818a]"
                      :aria-label="showResetPassword ? '隐藏新密码' : '显示新密码'"
                      @click.stop="showResetPassword = !showResetPassword"
                    >
                      <ShowIcon v-if="showResetPassword" class="h-[16px] w-[16px]" />
                      <HiddenIcon v-else class="h-[16px] w-[16px]" />
                    </button>
                  </div>
                </div>
              </label>

              <label class="block">
                <div
                  class="flex h-[46px] items-center justify-between rounded-[8px] border border-[rgba(5,21,36,0.06)] px-[16px]"
                >
                  <input
                    v-model="accountForm.resetPasswordConfirm"
                    :type="showResetPasswordConfirm ? 'text' : 'password'"
                    name="new-password-confirm"
                    autocomplete="new-password"
                    class="h-full min-w-0 flex-1 bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
                    placeholder="请再次输入新密码"
                    @input="handlePasswordInput('resetPasswordConfirm', $event)"
                    @keydown.enter="submit"
                  />
                  <div
                    class="ml-[12px] flex shrink-0 items-center justify-end gap-[24px] rtl:mr-[12px] rtl:ml-0 rtl:flex-row-reverse rtl:justify-start"
                  >
                    <button
                      v-if="accountForm.resetPasswordConfirm"
                      type="button"
                      class="flex h-[20px] w-[20px] cursor-pointer items-center justify-center rounded-full bg-[#eef0f4] text-[#8c8f97] transition-colors hover:bg-[#e3e6ec] hover:text-[#292a2e]"
                      aria-label="清空确认密码"
                      @click.stop="accountForm.resetPasswordConfirm = ''"
                    >
                      <CloseBoldIcon />
                    </button>
                    <button
                      type="button"
                      class="flex h-[16px] w-[16px] cursor-pointer items-center justify-center text-[#7d818a]"
                      :aria-label="showResetPasswordConfirm ? '隐藏确认密码' : '显示确认密码'"
                      @click.stop="showResetPasswordConfirm = !showResetPasswordConfirm"
                    >
                      <ShowIcon v-if="showResetPasswordConfirm" class="h-[16px] w-[16px]" />
                      <HiddenIcon v-else class="h-[16px] w-[16px]" />
                    </button>
                  </div>
                </div>
              </label>

              <p v-if="accountForm.resetPasswordError" class="text-[13px] leading-[20px] text-[#d84a4a]">
                {{ accountForm.resetPasswordError }}
              </p>
            </template>
          </div>

          <div :class="isEmailVerificationFlow ? 'pt-[32px]' : 'mt-auto pt-[32px]'">
            <button
              type="button"
              class="flex h-[46px] w-full cursor-pointer items-center justify-center rounded-[100px] bg-[#112d73] text-[14px] leading-[22px] font-semibold text-white hover:bg-[#0d245d]"
              :class="flowPrimaryEnabled ? '' : 'opacity-40'"
              :disabled="!flowPrimaryEnabled || accountLoading"
              @click="submit"
            >
              <span v-if="!accountLoading">{{ flowSubmitLabel }}</span>
              <span v-else class="login-spinner"></span>
            </button>
          </div>

          <button
            v-if="isEmailVerificationFlow || isPhoneBindEmail"
            type="button"
            class="absolute top-[456px] left-[155px] cursor-pointer text-[14px] leading-[22px] text-[#0d3f63] hover:text-[#112d73] rtl:right-[155px] rtl:left-auto"
            @click.stop="
              isPhoneBindEmail
                ? backFromPhoneBindEmail()
                : isRegisterVerifyEmail || isThirdPartyBindEmail
                  ? backFromRegister()
                  : backFromReset()
            "
          >
            {{ t('82919') }}
          </button>
        </section>
      </div>
    </section>

    <LazyLoginGeetest
      :is-geet="phoneShowGeetest"
      :state="2"
      product="bind"
      @geet-path="handlePhoneGeetestSuccess"
      @geet-error="handlePhoneGeetestError"
      @close-geet="closePhoneCaptchaLayers"
    />

    <LazyLoginGeetest
      :is-geet="registerGeetestVisible"
      :state="2"
      product="bind"
      @geet-path="handleRegisterGeetestSuccess"
      @geet-error="handleRegisterGeetestError"
      @close-geet="closeRegisterCaptchaLayers"
    />

    <LoginGraphical
      v-if="phoneShowGraphical"
      :phone="phoneForm.phone"
      :area-code="currentCountry.code"
      :figuresms-error="phoneForm.figuresmsError"
      @close="closePhoneCaptchaLayers"
      @figuresms="handlePhoneGraphicalSubmit"
    />

    <LoginGraphical
      v-if="registerGraphicalVisible"
      :phone="accountForm.registerPhone"
      :area-code="currentCountry.code"
      :figuresms-error="registerFiguresmsError"
      @close="closeRegisterCaptchaLayers"
      @figuresms="handleRegisterGraphicalSubmit"
    />
  </section>
</template>

<script setup lang="ts">
import ArrowDownIcon from '~/assets/icon/arrow-down.svg'
import CloseIcon from '~/assets/icon/close.svg'
import CloseBoldIcon from '~/assets/icon/close-bold.svg'
import HiddenIcon from '~/assets/icon/hidden.svg'
import ShowIcon from '~/assets/icon/show.svg'
import AppleIcon from '~/assets/icon/apple.svg'
import LinkedinIcon from '~/assets/icon/linkedin.png'
import PhoneIcon from '~/assets/icon/phone.svg'
import WechatIcon from '~/assets/icon/wechat.svg'
import ChinaFlag from '~/assets/images/footer/country-panel/china.png'
import { type AccountFlowView } from '~/utils/account-auth-flow'
import { resolveDefaultLoginRedirectUrl, resolveLoginRedirectUrl } from '~/utils/login-redirect'
import { takeThirdPartyRegistrationPayload, THIRD_PARTY_REGISTRATION_EVENT } from '~/utils/third-party-login'
import type { LoginCountry } from '~/composables/useLoginCountries'

type LoginTabKey = 'account' | 'phone'
type PasswordFormField = 'registerPassword' | 'registerPasswordConfirm' | 'resetPassword' | 'resetPasswordConfirm'

const { t, localePath } = useAppI18n()
const props = withDefaults(
  defineProps<{
    closebtn?: boolean
  }>(),
  {
    closebtn: true,
  },
)

const appStore = useAppStore()
const route = useRoute()
const matomo = useMatomo()
const {
  btnEnabled: phoneBtnEnabled,
  clearEmailRegistrationRequest,
  countDown: phoneCountDown,
  closeCaptchaLayers: closePhoneCaptchaLayers,
  form: phoneForm,
  handleGeetestError: handlePhoneGeetestError,
  handleGeetestSuccess: handlePhoneGeetestSuccess,
  handleGraphicalSubmit: handlePhoneGraphicalSubmit,
  isCountdown: phoneIsCountdown,
  loading: phoneLoading,
  requiresEmailRegistration: phoneRequiresEmailRegistration,
  reset: resetPhoneLogin,
  sendCode: sendPhoneCode,
  showGeetest: phoneShowGeetest,
  showGraphical: phoneShowGraphical,
  submit: submitPhoneLogin,
} = usePhoneLoginTab()
const {
  backFromRegister,
  backFromPhoneBindEmail,
  backFromReset,
  clearAccountAndBackToEntry,
  closeRegisterCaptchaLayers,
  currentCountry,
  form: accountForm,
  handleRegisterGeetestError,
  handleRegisterGeetestSuccess,
  handleRegisterGraphicalSubmit,
  isPrimaryEnabled: accountPrimaryEnabled,
  loading: accountLoading,
  openResetFlow,
  registerCountdown,
  registerEmailCountdown,
  registerEmailIsCountdown,
  registerFiguresmsError,
  registerGraphicalVisible,
  registerGeetestVisible,
  registerIsCountdown,
  reset: resetAccountFlow,
  resetCountdown,
  resetIsCountdown,
  sendRegisterCode,
  sendRegisterEmailCode,
  sendPhoneBindEmailCode,
  sendResetCode,
  startEmailRegistration,
  startThirdPartyBindEmail,
  startPhoneBindEmail,
  submit: submitAccountFlow,
  view: accountView,
} = useAccountAuthFlow()
const { handleGoogleAuthSuccess, handleSocialLogin, handleTelegramAuthSuccess, initThirdPartyLogin } =
  useThirdPartyLogin()

const narrow = ref(false)
const activeTab = ref<LoginTabKey>('account')
const countryPanelVisible = ref(false)
const thirdPartyLoginInitialized = ref(false)
const showLoginPassword = ref(false)
const showRegisterPassword = ref(false)
const showRegisterPasswordConfirm = ref(false)
const showResetPassword = ref(false)
const showResetPasswordConfirm = ref(false)
let previousBodyOverflow = ''

// 需要在同一登录弹窗中承载的账号流程页面。
const accountFlowViews: AccountFlowView[] = [
  'phoneBindEmail',
  'registerVerifyEmail',
  'thirdPartyBindEmail',
  'registerCreatePassword',
  'registerBindPhone',
  'resetVerifyEmail',
  'resetNewPassword',
]

const socialItems = [
  { key: 'google', label: 'Google 登录' },
  { key: 'apple', label: 'Apple 登录' },
  { key: 'wechat', label: '微信登录' },
  { key: 'linkedin', label: 'LinkedIn 登录' },
  { key: 'telegram', label: 'Telegram 登录' },
] as const

// 微信登录暂时不在弹窗展示，保留 provider 定义以便后续恢复时不影响登录逻辑。
const visibleSocialItems = computed(() => socialItems.filter((item) => item.key !== 'wechat'))

const normalizedAreaCode = computed(() => {
  const code = currentCountry.value.code || '0086'
  return code.startsWith('00') ? code.slice(2) : code.replace(/^\+/, '')
})

const isAccountFlowView = computed(() => accountFlowViews.includes(accountView.value))
/** 忘记密码的邮箱验证页使用设计稿指定的垂直布局。 */
const isResetVerifyEmail = computed(() => accountView.value === 'resetVerifyEmail')
/** 手机号未注册后按设计稿展示邮箱绑定表单。 */
const isPhoneBindEmail = computed(() => accountView.value === 'phoneBindEmail')
/** 手机号未注册后，使用设计稿中的邮箱注册验证页。 */
const isRegisterVerifyEmail = computed(() => accountView.value === 'registerVerifyEmail')
/** 第三方未注册时在当前页承接的邮箱绑定步骤。 */
const isThirdPartyBindEmail = computed(() => accountView.value === 'thirdPartyBindEmail')
const isEmailVerificationFlow = computed(
  () =>
    isResetVerifyEmail.value || isRegisterVerifyEmail.value || isPhoneBindEmail.value || isThirdPartyBindEmail.value,
)
const showLoginLayer = computed(() => appStore.loginShow)
const isThirdPartyRegisterBindPhonePopup = computed(
  () => route.query.type === 'register' && accountView.value === 'registerBindPhone',
)
const isSubmitting = computed(() => (activeTab.value === 'phone' ? phoneLoading.value : accountLoading.value))

// 弹窗打开时，主登录区保持进入弹窗前的上下文展示，避免被弹窗表单状态带偏。
const visibleAccountView = computed<AccountFlowView>(() => {
  if (!isAccountFlowView.value) return accountView.value
  if (
    accountView.value === 'registerVerifyEmail' ||
    accountView.value === 'registerCreatePassword' ||
    accountView.value === 'registerBindPhone' ||
    accountView.value === 'phoneBindEmail' ||
    accountView.value === 'thirdPartyBindEmail'
  ) {
    return 'accountEntry'
  }
  return 'accountPasswordLogin'
})

const showForgotPasswordLink = computed(
  () =>
    activeTab.value === 'account' &&
    (visibleAccountView.value === 'accountEntry' || visibleAccountView.value === 'accountPasswordLogin') &&
    !isAccountFlowView.value,
)

// 主登录区按钮只跟随主区可见表单，避免创建密码输入影响背景按钮颜色。
const mainAccountPrimaryEnabled = computed(() => {
  if (visibleAccountView.value === 'accountEntry') {
    return Boolean(accountForm.account.trim().length >= 5 && accountForm.loginPassword.trim().length >= 6)
  }
  if (visibleAccountView.value === 'accountPasswordLogin') return Boolean(accountForm.loginPassword.trim().length >= 6)
  return accountPrimaryEnabled.value
})

const mainSubmitEnabled = computed(() => {
  return activeTab.value === 'phone' ? phoneBtnEnabled.value : mainAccountPrimaryEnabled.value
})

const submitLabel = computed(() => {
  if (activeTab.value === 'phone') return t('82902')
  return t('82902')
})

const submitButtonClass = computed(() => {
  const enabled = mainSubmitEnabled.value
  return enabled ? 'bg-[#112d73] text-white' : 'bg-[#112d73] text-white opacity-40'
})

const accountFlowTitleMap: Record<AccountFlowView, string> = {
  accountEntry: t('82902'),
  accountPasswordLogin: t('82902'),
  phoneBindEmail: '绑定邮箱',
  thirdPartyBindEmail: '绑定邮箱',
  registerVerifyEmail: t('85524'),
  registerCreatePassword: t('82921'),
  registerBindPhone: t('82923'),
  resetVerifyEmail: t('82906'),
  resetNewPassword: t('82915'),
}

const flowSubmitLabel = computed(() => {
  if (accountView.value === 'phoneBindEmail') return t('82902')
  if (accountView.value === 'thirdPartyBindEmail') return t('82902')
  if (accountView.value === 'registerBindPhone') return t('82902')
  if (isEmailVerificationFlow.value) return t('82414')
  return t('82922')
})

const flowTitle = computed(() => accountFlowTitleMap[accountView.value])
const flowPrimaryEnabled = computed(() => accountPrimaryEnabled.value)
/** 根据当前账户流程展示安全提示。 */
const flowDescription = computed(() => {
  if (accountView.value === 'phoneBindEmail') return '为了您的账户安全，请绑定邮箱'
  if (accountView.value === 'thirdPartyBindEmail') return '为了您的账户安全，请绑定邮箱'
  return accountView.value === 'registerBindPhone' ? '' : t('82913')
})

const updateViewport = () => {
  if (!import.meta.client) return
  narrow.value = window.innerWidth < 860
}

const resetVisibilityState = () => {
  countryPanelVisible.value = false
  showLoginPassword.value = false
  showRegisterPassword.value = false
  showRegisterPasswordConfirm.value = false
  showResetPassword.value = false
  showResetPasswordConfirm.value = false
}

/** 登录弹窗显示期间锁定页面滚动，关闭后恢复此前的页面滚动设置。 */
const syncLoginScrollLock = (visible: boolean) => {
  if (!import.meta.client) return

  if (visible) {
    previousBodyOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return
  }

  document.body.style.overflow = previousBodyOverflow
}

/**
 * 第三方 SDK 仅在登录弹窗首次展示后初始化，避免页面预加载产生无效授权容器。
 */
const ensureThirdPartyLoginInitialized = async () => {
  if (thirdPartyLoginInitialized.value) return
  await initThirdPartyLogin()
  thirdPartyLoginInitialized.value = true
}

const sanitizePasswordInput = (value: string) => value.replace(/[\u3400-\u9fff\uf900-\ufaff]/g, '')

const handlePasswordInput = (field: PasswordFormField, event: Event) => {
  const input = event.target as HTMLInputElement
  const sanitizedValue = sanitizePasswordInput(input.value)
  if (input.value !== sanitizedValue) {
    input.value = sanitizedValue
  }
  accountForm[field] = sanitizedValue
}

const switchTab = (nextTab: LoginTabKey) => {
  if (activeTab.value === nextTab) {
    return
  }

  activeTab.value = nextTab
  resetVisibilityState()
  resetPhoneLogin()
  resetAccountFlow()
  matomo.trackEvent('af_login_pop_click', {
    af_type: nextTab === 'account' ? '邮箱/登录' : '手机号',
  })
}

const sendCodeMatomo = () => {
  matomo.trackEvent('af_phone_vercode_get', {
    af_judge: '手机号验证',
    af_type: '',
    af_content: '',
  })
}
const handleCountrySelect = (country: LoginCountry) => {
  appStore.setuserCountry(country)
  countryPanelVisible.value = false

  if (activeTab.value === 'phone' && !isAccountFlowView.value) {
    phoneForm.phone = ''
    phoneForm.smsCode = ''
    phoneForm.phoneError = ''
    phoneForm.smsError = ''
    phoneForm.figuresmsError = ''
    return
  }

  accountForm.registerPhone = ''
  accountForm.registerSmsCode = ''
  accountForm.registerPhoneError = ''
  accountForm.registerSmsError = ''
  accountForm.registerFiguresmsError = ''
}

/**
 * Google 官方按钮返回 credential 后，沿用当前三方登录业务回调。
 */
const handleGoogleCredential = (credential: string) => {
  handleGoogleAuthSuccess(credential)
}

/**
 * Telegram 官方 widget 返回授权信息后，交给统一三方登录流程处理。
 */
const handleTelegramAuth = (payload: Parameters<typeof handleTelegramAuthSuccess>[0]) => {
  handleTelegramAuthSuccess(payload)
}

const matomoLogo = (type: string) => {
  matomo.trackEvent('af_login_pop_click', {
    af_type: type,
  })
}
const submit = async () => {
  if (!mainSubmitEnabled.value && !isAccountFlowView.value) {
    return
  }

  if (isAccountFlowView.value) {
    await submitAccountFlow()
    matomo.trackEvent('af_account_next', {
      af_type: '邮箱/账号',
    })
    return
  }

  if (activeTab.value === 'phone') {
    await submitPhoneLogin()
    if (phoneRequiresEmailRegistration.value) {
      startPhoneBindEmail(phoneForm.phone, phoneForm.smsCode, phoneForm.phoneVerifyRequestId)
      clearEmailRegistrationRequest()
      return
    }
    matomo.trackEvent('af_login_phone', {
      af_type: 'phone',
    })
    return
  }

  await submitAccountFlow()
  matomo.trackEvent('af_account_next', {
    af_type: '邮箱/账号',
  })
}

const resetModalState = () => {
  activeTab.value = 'account'
  resetVisibilityState()
  resetPhoneLogin()
  resetAccountFlow()

  const thirdPartyPayload = takeThirdPartyRegistrationPayload()
  if (thirdPartyPayload) {
    startThirdPartyBindEmail(String(thirdPartyPayload.email || ''), thirdPartyPayload)
    activeTab.value = 'account'
  }
}

const close = () => {
  if (isThirdPartyRegisterBindPhonePopup.value && import.meta.client) {
    window.location.href = resolveLoginRedirectUrl(
      route.query.returnurl,
      resolveDefaultLoginRedirectUrl(appStore.LanguageCode || 'en'),
      window.location.origin,
    )
    return
  }
  matomoLogo('关闭')
  appStore.setLoginShow(false)
  resetModalState()
}

watch(
  () => appStore.loginShow,
  async (visible) => {
    syncLoginScrollLock(visible)

    if (visible) {
      matomo.trackEvent('af_login_pop')
      resetModalState()
      await nextTick()
      await ensureThirdPartyLoginInitialized()
      return
    }

    countryPanelVisible.value = false
  },
  { immediate: true },
)

watch(isAccountFlowView, (visible) => {
  if (visible) {
    matomo.trackEvent('af_login_password_pop')
  }
})

onMounted(() => {
  updateViewport()

  if (import.meta.client) {
    window.addEventListener('resize', updateViewport)
    window.addEventListener(THIRD_PARTY_REGISTRATION_EVENT, resetModalState)
  }
})

onBeforeUnmount(() => {
  if (import.meta.client) {
    window.removeEventListener('resize', updateViewport)
    window.removeEventListener(THIRD_PARTY_REGISTRATION_EVENT, resetModalState)
    document.body.style.overflow = previousBodyOverflow
  }
})
</script>

<style scoped lang="less">
.login-modal-panel {
  animation: loginInDown 0.85s both;
}

.login-account-flow {
  label > div {
    border: 0 !important;
    border-bottom: 1px solid rgba(5, 21, 36, 0.06) !important;
    border-radius: 0 !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

.login-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: loginSpin 0.8s linear infinite;
}

@keyframes loginInDown {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes loginSpin {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
